import React from 'react';
import { useParams } from 'react-router-dom';
import { getPolyglot } from '../../../../i18n';
import { NavigationPath } from '../../../DeviceManager/navigations/navigationPath';
import PolicyTitle from '../PolicyDetails/PolicyTitle';

export function useNavigationPath(): NavigationPath[] {
  const params = useParams<{
    workspaceId: string;
    policyId: string;
  }>();
  const polyglot = getPolyglot();
  const sectionsNavigation: NavigationPath[] = [
    {
      content: polyglot.t('stoerk_id.nav_title'),
      href: '/account/my-account',
      key: 'my-account',
    },
    {
      content: (
        <PolicyTitle
          sectionTitle={polyglot.t('incident.policy.policy_detail_title')}
        />
      ),
      href: `/account/my-account/workspace/${params.workspaceId}/policy/${params.policyId}`,
      key: 'policy-create',
    },
    {
      content: polyglot.t('incident.policy.edit_policy'),
      href: `/account/my-account/workspace/${params.workspaceId}/policy/${params.policyId}/edit`,
      key: 'policy-edit',
    },
  ];

  return sectionsNavigation;
}
